import React, { useCallback } from 'react'
import { I18n } from 'react-redux-i18n'
import { useSelector } from 'react-redux'

import SaveToastNotification from 'utils/toasts/SaveToastNotification'
import ContainerBox from '../components/ContainerBox'
import SwitchControl from '../components/SwitchControl'
import { company as companyAPI } from 'api'

function AutomaticAssignmentSwitch() {
  const { isActive } = useSelector((store) => store.modules.automaticAssignment)

  const onChange = useCallback(async (value) => {
    try {
      await companyAPI.assignations.postAutomaticAssigment(value)

      SaveToastNotification.ok()
    } catch(error) {
      SaveToastNotification.error()
    }
  }, [])

  return (
    <ContainerBox
      title={I18n.t(`configuration_messages_automatic_assignment_title`)}
    >
      <SwitchControl
        value={isActive}
        onChange={onChange}
      />
    </ContainerBox>
  )
}

export default AutomaticAssignmentSwitch
